import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import Text from "../../../../Diathrive/src/components/elements/Text";
import Button from "../../../../Diathrive/src/components/elements/Button";
import Divider from "../../../../Diathrive/src/components/elements/Divider";
import { BUTTON_TYPES, COLORS } from "../../../../Diathrive/src/utils/Constants";
import { getUserProfileData } from "../../../../Diathrive/src/utils/GeneralStorage";
import { fetchApi } from "../../../../Diathrive/src/utils/ApiHelper";
import { HTTP_METHODS } from "../../../../Diathrive/src/utils/URLConstants";
import styles from "./styles";

const ConfirmAppointmentWeb = ({ eventType, selectedTime, onConfirmed, onBack }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const userProfile = useRef(null);

  useEffect(() => {
    (async () => {
      userProfile.current = await getUserProfileData();
    })();
  }, []);

  const formattedDate = moment(selectedTime).format("dddd, MMMM D, YYYY");
  const formattedTime = moment(selectedTime).format("h:mm A");

  const onConfirm = async () => {
    const profile = userProfile.current;
    if (!profile) return;

    setLoading(true);
    setError(null);

    try {
      const tz = Intl?.DateTimeFormat?.()?.resolvedOptions?.()?.timeZone || "America/Chicago";
      await fetchApi(HTTP_METHODS.POST, "patients/calendly/book", {
        event_type_uri: eventType.uri,
        event_type_name: eventType.name,
        start_time: selectedTime,
        duration: eventType.duration,
        email: profile.email,
        name: `${profile.firstname} ${profile.lastname}`,
        advisor_uri: eventType.advisorUri,
        timezone: tz,
      });
      alert(`Appointment booked for ${formattedDate} at ${formattedTime}`);
      onConfirmed();
    } catch (e) {
      const message =
        typeof e === "string"
          ? e
          : "Failed to book appointment. Please try again.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.confirmCard}>
        <Text variation="Subtitle2Bold" color={COLORS.black}>
          Appointment Details
        </Text>
        <Divider top={16} color={COLORS.greyLight} />
        <div style={{ ...styles.confirmRow, marginTop: 16 }}>
          <Text variation="Text1Regular" color={COLORS.grey2}>Type</Text>
          <Text variation="Body1SemiBold" color={COLORS.black}>{eventType.name}</Text>
        </div>
        <div style={styles.confirmRow}>
          <Text variation="Text1Regular" color={COLORS.grey2}>Advisor</Text>
          <Text variation="Body1SemiBold" color={COLORS.black}>{eventType.advisorName}</Text>
        </div>
        <div style={styles.confirmRow}>
          <Text variation="Text1Regular" color={COLORS.grey2}>Date</Text>
          <Text variation="Body1SemiBold" color={COLORS.black}>{formattedDate}</Text>
        </div>
        <div style={styles.confirmRow}>
          <Text variation="Text1Regular" color={COLORS.grey2}>Time</Text>
          <Text variation="Body1SemiBold" color={COLORS.black}>{formattedTime}</Text>
        </div>
        <div style={styles.confirmRow}>
          <Text variation="Text1Regular" color={COLORS.grey2}>Duration</Text>
          <Text variation="Body1SemiBold" color={COLORS.black}>{eventType.duration} minutes</Text>
        </div>
      </div>
      <Text variation="Text2Medium" color={COLORS.grey2} topMargin={8}>
        You will receive a calendar invite and reminder notifications.
      </Text>
      {error && (
        <Text variation="Text1Regular" color={COLORS.red} topMargin={12}>
          {error}
        </Text>
      )}
      <div style={{ ...styles.typeSelectButtons, marginTop: 24 }}>
        <Button
          style={{ flex: 1 }}
          buttonType={BUTTON_TYPES.Bordered}
          title="Back"
          onPress={onBack}
        />
        <Button
          disabled={loading}
          style={{ flex: 1 }}
          buttonType={BUTTON_TYPES.Filled}
          titleColor={COLORS.white}
          title={loading ? "Booking..." : "Confirm Appointment"}
          onPress={onConfirm}
        />
      </div>
    </div>
  );
};

export default ConfirmAppointmentWeb;
